module.exports = __webpack_public_path__ + "static/media/hall-AG.ef9386be.svg";